// The ClearMakes mark + wordmark. The mark is served from /public so every app
// (site, login, workspace) shows the identical asset.
export const Logo = ({
  className = "",
  showWordmark = true,
  size = 26,
}: {
  className?: string;
  showWordmark?: boolean;
  size?: number;
}) => {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/logo-mark-256.png"
        alt=""
        width={size}
        height={size}
        className="shrink-0 select-none"
        draggable={false}
      />
      {showWordmark && (
        <span className="text-[17px] font-semibold tracking-[-0.02em] text-foreground">ClearMakes</span>
      )}
    </span>
  );
};
